module.exports = __webpack_public_path__ + "static/media/welcome-bonus-web.5da51725.png";